module.exports = __webpack_public_path__ + "static/img/app-lt.f0c16ed5.png";